export const environment = {
  production: true
};



// WEBPACK FOOTER //
// /mnt/e/apps/architect3/client/src/environments/environment.ts